export default __webpack_public_path__ + "static/media/mascot.aedfd8b9.png";